import { SvgIcon, SxProps } from "@mui/material";

import SvgEllipsisHorizontalIcon from "jsx:../../../Images/Icons/FontAwesome/light/ellipsis.svg";

export function EllipsisHorizontalIcon(props: SxProps) {
    return (
        <SvgIcon
            component={SvgEllipsisHorizontalIcon}
            inheritViewBox
            sx={props}
        />
    );
}
